var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-misc"},[_c('SimpleNavApp'),_c('main',{staticClass:"custom-main"},[_c('div',{staticClass:"page-misc-card"},[_vm._t("default")],2)]),_c('FooterInitial')],1)}
var staticRenderFns = []

export { render, staticRenderFns }